import { useSyncExternalStore } from 'react';

const consulta = '(prefers-reduced-motion: reduce)';

function observar(aoMudar: () => void) {
  const media = window.matchMedia(consulta);
  media.addEventListener('change', aoMudar);
  return () => media.removeEventListener('change', aoMudar);
}

/** A preferência também pode mudar com a página aberta. */
export function useMovimentoReduzido() {
  return useSyncExternalStore(observar, () => window.matchMedia(consulta).matches, () => true);
}
